import type { VehicleEditFormValue } from '../components/VehicleEditForm';

export const BLANK_FORM: VehicleEditFormValue = {
  vehicle: { id: '' },
};
